export const getEnvDomain = (usingQaDomain = true) => {
  var host = window.location.hostname.toLowerCase();
  var envDomain = '.';
  if (host.includes('.testing.')) {
    envDomain = '.testing.';
    if (usingQaDomain && host.includes('-')) {
      envDomain = '-' + host.split('-')[1].replace('cet.ac.il', '');
    }
  }
  else if (host.includes('.dev.') || host.includes('localhost')) {
    envDomain = '.dev.';
  }
  return envDomain;
};

export const envDomain = getEnvDomain();

export const nairobiGateway = `https://nairobigateway${envDomain}cet.ac.il`;
//export const apiGatewayUrl = `https://apigateway${envDomain}cet.ac.il`;
export const nairobiSite = `https://myofek${envDomain}cet.ac.il`;

export const get = (url) => fetch(url).then((res) => res.json()).then(json => json);

export const post = (url, data) => {
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');

  var raw = JSON.stringify(data);

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
    credentials: 'include',
  };

  return fetch(url, requestOptions);
};